var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0271 18.3751L23.1262 23.9382L14.2252 18.3751V16.1499L23.1262 21.713L32.0271 16.1499M32.0271 13.9247H14.2252C12.9902 13.9247 12 14.9149 12 16.1499V29.5013C12 30.0915 12.2344 30.6575 12.6518 31.0748C13.0691 31.4921 13.6351 31.7265 14.2252 31.7265H32.0271C32.6172 31.7265 33.1832 31.4921 33.6006 31.0748C34.0179 30.6575 34.2523 30.0915 34.2523 29.5013V16.1499C34.2523 15.5597 34.0179 14.9937 33.6006 14.5764C33.1832 14.1591 32.6172 13.9247 32.0271 13.9247Z",
    fill: "#43377C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3841,
    cy: 22.8257,
    r: 21.7523,
    stroke: "#43377C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.96432a8e66d75903075541f92b0e3380.svg";
export { ForwardRef as ReactComponent };